import { SOURCE_EXCERPT_PAGE_NUMBER_BASE } from './activityBatchConversion.constants';

export const SourceExcerptRegionModel = {
  page: 0,
  bbox: [],
};

export const SourceExcerptModel = {
  contract_version: '',
  coordinate_space: '',
  page_number_base: SOURCE_EXCERPT_PAGE_NUMBER_BASE,
  page: 0,
  regions: [],
  source_sha256: '',
  localization_method: '',
};

export const ActivityValidationModel = {
  score: 0,
  recommendation: '',
  feedback: '',
};

// Trazabilidad de conversión de cada actividad (GET :id/activities). En lotes `generate` los
// campos opcionales quedan en null/[] y no se muestran; `retype_suggestions` se conserva sin UI en v1.
export const ConversionTraceModel = {
  template_type: '',
  validation: null,
  answer_origin: null,
  source_excerpt: null,
  retype_suggestions: [],
};

export const UnconvertibleItemModel = {
  guid: '',
  inventory_item_id: '',
  position: 0,
  statement: '',
  reason: '',
  reason_detail: '',
  required_template: '',
  source_excerpt: null,
};

// Formulario de la pantalla de digitalización: PDF existente, rango inclusivo y catálogo
// pedagógico mínimo. Sin fuente alternativa, prompt, idioma, dificultad ni tipos.
// `has_metadata` conserva el significado de mapContentToPdfSource (el PDF trae ALGÚN metadato) y
// `is_pedagogy_complete` dice si vienen los tres obligatorios: con metadatos parciales hay que
// anunciar el autorrelleno y, aun así, pedir que se complete lo que falta.
export const ConversionFormModel = {
  name: '',
  pdf_file_name: '',
  source_ref_guid: '',
  source_url: '',
  page_count: 0,
  has_metadata: true,
  is_pedagogy_complete: true,
  page_from: '',
  page_to: '',
  country: null,
  educationLevel: null,
  educationYear: null,
  discipline: null,
};

export const UnconvertiblePageModel = {
  items: [],
  total: 0,
  limit: 0,
  offset: 0,
};
